import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import theme from '../../../styles/theme';

const CheckboxContainer = styled.label`
  display: inline-block;
  cursor: pointer;
  user-select: none;
`;

const Input = styled.input`
  display: none;

  & + div {
    width: ${theme.iconSizes.s}px;
    height: ${theme.iconSizes.s}px;
    border: 1.5px solid ${theme.colors.gray500};
    border-radius: 3px;
  }

  &:checked + div {
    border: 1.5px solid ${theme.colors.gray600};
  }

  &:checked + div:after {
    content: '✓';
    display: inline-block;
    width: 100%;
    height: 100%;
    text-align: center;
    color: ${theme.colors.fontBase};
  }

  &:hover + div {
    background-color: ${theme.colors.bgInputHover};
  }
`;

const Checkbox = ({ name, defaultChecked, style, onChange }) => {
  return (
    <CheckboxContainer style={style}>
      <Input
        type="checkbox"
        name={name}
        defaultChecked={defaultChecked}
        onChange={onChange}
      />
      <div />
    </CheckboxContainer>
  );
};

Checkbox.defaultProps = {
  defaultChecked: false,
  style: {},
  onChange: () => {},
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  defaultChecked: PropTypes.bool,
  style: PropTypes.object,
};

export default Checkbox;
